export class HttpClient {

    async get( url ) {

        const resp = await fetch( url, {
            headers: {
                "Content-Type": "application/json",
              },
        } );
        const data = await resp.json();

        return { data, status: resp.status };
    }

    async post( url ) {

        const resp = await fetch( url, {
            method: "POST"
        });
        const data = await resp.json();

        return { data, status: resp.status };
    }

    async postBody( url, bodyData = {}) {
        try {
            const resp = await fetch(
                url,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(bodyData)
                }
            );
            
            const data = await resp?.json();
            // console.log("postBody response", data, resp.status)
            if(resp.status!==200){
                return { data : false, status:'error'}
            }
            return { data, status: resp.status };  
        }catch (error){
            console.error("Error postBody:", error);
            return { data : false, status:'error'}
        }
    }
}